// SPDX-License-Identifier: AGPL-3.0-or-later

import type {KnownCosmeticType} from '@app/features/cosmetics/state/Cosmetics';

export type ShopSurface = 'profile' | 'chat' | 'member_list' | 'voice';

// Where the app draws each type; the detail dialog shows these surfaces and no others. A type missing here is unknown
// to this client and stays out of the shop.
export const SHOP_SURFACES: Record<KnownCosmeticType, ReadonlyArray<ShopSurface>> = {
	avatar_decoration: ['profile', 'chat', 'member_list', 'voice'],
	avatar_ultra: ['profile', 'chat', 'member_list', 'voice'],
	profile_effect: ['profile'],
	nameplate: ['member_list'],
	room_character: ['voice'],
	room_face: ['voice'],
	room_hair: ['voice'],
	room_top: ['voice'],
	room_bottom: ['voice'],
	room_shoes: ['voice'],
	room_costume: ['voice'],
	room_hat: ['voice'],
	room_glasses: ['voice'],
	room_accessory: ['voice'],
	room_emote: ['voice'],
};

export function isShopCosmeticType(type: string): type is KnownCosmeticType {
	return Object.hasOwn(SHOP_SURFACES, type);
}

export function detailSurfacesFor(types: ReadonlyArray<string>): Array<Exclude<ShopSurface, 'voice'>> {
	return (['profile', 'member_list', 'chat'] as const).filter((surface) =>
		types.some((type) => isShopCosmeticType(type) && SHOP_SURFACES[type].includes(surface)),
	);
}
